import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { buildTitle } from "@/config/seoTitles";

const VerifyEmail = lazy(() => import("@/pages/VerifyEmail"));

export const Route = createFileRoute("/bekrafta-epost")({
  head: () => ({
    meta: [
      { title: buildTitle("Bekräfta e-post", "page") },
      {
        name: "description",
        content:
          "Bekräfta din e-postadress via länken i mailet för att aktivera ditt konto på Elmarknad.se.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: buildTitle("Bekräfta e-post", "page") },
      {
        property: "og:description",
        content: "Verifiera din e-postadress för att aktivera ditt konto.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <VerifyEmail />,
});
